const DURATION_OPTIONS = [
  { minutes: 30, label: 'Half hour' },
  ...Array.from({ length: 47 }, (_, i) => {
    const h = 1 + i * 0.5;
    return { minutes: Math.round(h * 60), label: `${h} hour${h === 1 ? '' : 's'}` };
  }),
  { minutes: 2880, label: '2 days' },
  { minutes: 4320, label: '3 days' },
  { minutes: 10080, label: '1 week' },
  { minutes: 20160, label: '2 weeks' },
  { minutes: 43200, label: '1 month' },
];

export function formatDurationLabel(minutes) {
  const n = Number(minutes) || 60;
  const found = DURATION_OPTIONS.find((o) => o.minutes === n);
  if (found) return found.label;
  if (n < 60) return `${n} min`;
  if (n < 1440) {
    const h = n / 60;
    return Number.isInteger(h) ? `${h} hour${h === 1 ? '' : 's'}` : `${h} hours`;
  }
  const d = n / 1440;
  if (Number.isInteger(d) && d < 30) return `${d} day${d === 1 ? '' : 's'}`;
  return `${Math.round(d)} days`;
}

export function formatServicePrice(rate, durationMinutes = 60) {
  const amount = Number(rate) || 0;
  const duration = formatDurationLabel(durationMinutes);
  return `₹${amount.toLocaleString('en-IN')} · ${duration}`;
}

export function getServiceDurationMinutes(service) {
  return Number(service?.duration_minutes) || 60;
}

export function getServiceDisplayPrice(service) {
  const minutes = getServiceDurationMinutes(service);
  const rate = service?.offer_price > 0 ? service.offer_price : service?.default_rate;
  return formatServicePrice(rate, minutes);
}
